import React from 'react';

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M19.8002 19.8002H0.200195V0.200195H19.8002V19.8002ZM1.8002 18.2002H6.1802V14.8002H1.7992L1.8002 18.2002ZM12.7192 14.8002H7.7802V18.2002H12.7192V14.8002ZM18.1992 14.8002H14.3192V18.2002H18.2002L18.1992 14.8002ZM18.1992 13.2002V9.8002H14.3192V13.2002H18.1992ZM1.7992 13.2002H6.1802V9.8002H1.7992V13.2002ZM12.7192 9.8002H7.7802V13.2002H12.7192V9.8002ZM18.2002 1.8002H1.8002L1.7992 8.2002H18.1992L18.2002 1.8002ZM13.8002 4.2002V5.8002H6.2002V4.2002H13.8002Z" fill="#333333"/>
  </svg>
);

export default CalendarIcon;
